import { Divider, Stack, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import GoalType from '../GoalType';
import pceIconNormal from '../resources/images/customers_default.svg';
import pceIconHover from '../resources/images/customers_hover.svg';
import pceIconSelected from '../resources/images/customers_selected.svg';
import qsIconNormal from '../resources/images/quality_default.svg';
import qsIconHover from '../resources/images/quality_hover.svg';
import qsIconSelected from '../resources/images/quality_selected.svg';
import ipIconNormal from '../resources/images/workforce_default.svg';
import ipIconHover from '../resources/images/workforce_hover.svg';
import ipIconSelected from '../resources/images/workforce_selected.svg';
import { ConfigStore } from '../stores/ConfigStore';

const goals_list = [
    {
        id: GoalType.preventCustomerEscalation,
        normal: pceIconNormal,
        hover: pceIconHover,
        selected: pceIconSelected,
        title: 'prevent-escalation',
        description: 'prevent-escalation-desc',
        trackerId: 'Customers',
    },
    {
        id: GoalType.improveTeamPerformance,
        normal: ipIconNormal,
        hover: ipIconHover,
        selected: ipIconSelected,
        title: 'improve-performance',
        description: 'improve-performance-desc',
        trackerId: 'Workforce',
    },
    {
        id: GoalType.upgradeQualityStrategy,
        normal: qsIconNormal,
        hover: qsIconHover,
        selected: qsIconSelected,
        title: 'quality-strategy',
        description: 'quality-strategy-desc',
        trackerId: 'Quality',
    },
];

interface GoalsProps {
    configStore: ConfigStore;
}

const Goals: FunctionComponent<GoalsProps> = (props: GoalsProps) => {
    const { t } = useTranslation();
    const { selected_goal, setSelectedGoal } = props.configStore;

    const handleGoalMouseOver = (e: any, goal: any) => {
        if (selected_goal && selected_goal.id === goal.id) {
            return;
        }

        e.currentTarget.src = goal.hover;
    };

    const handleGoalMouseOut = (e: any, goal: any) => {
        if (selected_goal && selected_goal.id === goal.id) {
            return;
        }

        e.currentTarget.src = goal.normal;
    };

    const handleGoalClicked = (e: any, goal: any) => {
        e.currentTarget.src = goal.selected;
        setSelectedGoal(goal);
    };

    const selected_goal_id = selected_goal ? selected_goal.id : null;
    return (
        <Stack direction="column" className="CreateGoals">
            <Typography component="div" className="StepTitle">
                {t('goals.title')}
            </Typography>
            <Typography component="div" className="StepDescription">
                {t('goals.description')}
            </Typography>
            <Stack direction="column">
                {goals_list.map((goal, index) => (
                    <Stack direction="column" key={index}>
                        <Stack direction="row" className="Goal">
                            <img
                                alt=""
                                id={goal.id}
                                src={goal.id === selected_goal_id ? goal.selected : goal.normal}
                                onMouseOver={(e) => handleGoalMouseOver(e, goal)}
                                onMouseOut={(e) => handleGoalMouseOut(e, goal)}
                                onClick={(e) => handleGoalClicked(e, goal)}
                            />
                            <Stack direction="column">
                                <Typography component="div" className="GoalSubTitle">
                                    {t(`goals.${goal.title}`)}
                                </Typography>
                                <Typography component="div" className="GoalSubDescription">
                                    {t(`goals.${goal.description}`)}
                                </Typography>
                            </Stack>
                        </Stack>
                        <Divider />
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export default Goals;
export { goals_list };
